export const firebaseModule = 'firebase';
